import { ComboboxSingleSelect } from '@eggplant/pattern-library'
import {
  type Options,
  type SpaceRole
} from '@eggplant/types'

interface Props {
  onChange: (value: SpaceRole) => void
  value: string
  prompt: string
  isDisabled?: boolean
}

const roleOptions: Options = [
  {
    label: 'Space Admin',
    value: 'full'
  },
  {
    label: 'Space User',
    value: 'readwrite'
  },
  {
    label: 'Space Viewer',
    value: 'read'
  }
]

const SelectUserGroupRole = ({
  onChange,
  prompt,
  value,
  isDisabled = false
}: Props) =>
  <ComboboxSingleSelect
    isClearable={false}
    isDisabled={isDisabled}
    isHighlighted={false}
    key={value}
    onChange={role => onChange(role as SpaceRole)}
    options={roleOptions}
    prompt={prompt}
    value={value}
  />

export default SelectUserGroupRole
